<ph-dialog [open]="open"
           size="sm"
           icon="shield-check"
           heading="Additional Verification Required"
           [description]="subtitle"
           [noClose]="disableClose"
           (ph-close)="onDialogClose()">

    <ng-container *ngIf="open">
        <ng-container *ngIf="!type">
            <ph-action-list [items]="methodItems" (ph-select)="onMethodSelect($event.detail)"></ph-action-list>
        </ng-container>

        <ph-stack *ngIf="type && type !== 'recovery'">
            <ph-stack gap="snug" align="center">
                <ph-digit-input #digits
                                digits="6"
                                aria-label="Verification code"
                                auto-focus
                                [value]="code"
                                [disabled]="isSubmitting || isSuccess"
                                [hasError]="hasError"
                                (ph-change)="onCodeChange($event.detail)"
                                (ph-complete)="submit($event.detail)"></ph-digit-input>

                <ph-hint [hasError]="hasError">{{ hintText }}</ph-hint>
            </ph-stack>

            <ph-stack *ngIf="showResendRow" gap="tight" align="center">
                <ph-hint [hasError]="isExpired || smsSendFailed">{{ resendStatus }}</ph-hint>
                <ph-toolbar gap="tight" nowrap>
                    <ph-hint>Didn't get a code?</ph-hint>
                    <ph-link-button variant="primary"
                                    size="small"
                                    e2eId="confirm-2fa-resend"
                                    [disabled]="isResending || isSubmitting || isSuccess"
                                    (click)="resendCode()">{{ isResending ? 'Sending…' : 'Resend code' }}</ph-link-button>
                </ph-toolbar>
            </ph-stack>

            <ng-container *ngIf="showTrustDevice">
                <ph-divider></ph-divider>
                <ph-field>
                    <ph-field inline>
                        <ph-checkbox e2eId="confirm-2fa-trust-device"
                                     [checked]="trustDevice"
                                     (ph-change)="trustDevice = $event.detail"></ph-checkbox>
                        <ph-label>Trust this browser</ph-label>
                    </ph-field>
                    <ph-hint>Don't ask for a code again on this browser for 30 days. Only use on personal devices.</ph-hint>
                </ph-field>
            </ng-container>

            <ph-stack *ngIf="canUseRecoveryCode" align="center">
                <ph-link-button variant="primary"
                                e2eId="confirm-2fa-use-recovery"
                                [disabled]="isSubmitting || isSuccess"
                                (click)="setRecoveryType()">Use a recovery code instead</ph-link-button>
            </ph-stack>
        </ph-stack>

        <ph-stack *ngIf="type === 'recovery'">
            <ph-stack gap="snug">
                <input type="text"
                       class="recovery-code-input"
                       mask="AAAAA-AAAAA"
                       e2eId="confirm-2fa-recovery-input"
                       aria-label="Recovery code"
                       placeholder="XXXXX-XXXXX"
                       autocomplete="one-time-code"
                       [(ngModel)]="recoveryCode"
                       [disabled]="isSubmitting || isSuccess"
                       (keyup.enter)="submitRecovery()" />

                <ph-stack align="center">
                    <ph-hint [hasError]="hasError">{{ recoveryHint }}</ph-hint>
                </ph-stack>
            </ph-stack>

            <ng-container *ngIf="showTrustDevice">
                <ph-divider></ph-divider>
                <ph-field>
                    <ph-field inline>
                        <ph-checkbox [checked]="trustDevice" (ph-change)="trustDevice = $event.detail"></ph-checkbox>
                        <ph-label>Trust this browser</ph-label>
                    </ph-field>
                    <ph-hint>Don't ask for a code again on this browser for 30 days. Only use on personal devices.</ph-hint>
                </ph-field>
            </ng-container>
        </ph-stack>
    </ng-container>

    <ph-actions slot="footer" *ngIf="!type">
        <ph-button variant="secondary" mode="filled" (click)="cancel()">Cancel</ph-button>
    </ph-actions>

    <ph-actions slot="footer" align="between" *ngIf="type && type !== 'recovery'">
        <ph-button *ngIf="canGoBack" variant="secondary" mode="filled" (click)="goBack()">Back</ph-button>
        <ph-button *ngIf="!canGoBack" variant="secondary" mode="filled" (click)="cancel()">Cancel</ph-button>
        <ph-button e2eId="confirm-2fa-submit"
                   [disabled]="code.length < 6 || isSubmitting || isSuccess"
                   (click)="submit(code)">{{ verifyLabel }}</ph-button>
    </ph-actions>

    <ph-actions slot="footer" align="between" *ngIf="type === 'recovery'">
        <ph-button variant="secondary" mode="filled" (click)="backFromRecovery()">Back</ph-button>
        <ph-button e2eId="confirm-2fa-recovery-submit"
                   [disabled]="recoveryCode.trim().length < 10 || isSubmitting || isSuccess"
                   (click)="submitRecovery()">{{ verifyLabel }}</ph-button>
    </ph-actions>
</ph-dialog>
